import type { NamespaceSchema } from './types';

export const userSettings: NamespaceSchema = {
  namespace: 'user-settings',
  label: 'Users',
  description: 'Defaults applied at signup + password / verification policy.',
  sections: [
    {
      label: 'Signup',
      fields: [
        { kind: 'boolean', key: 'allow_signup', label: 'Public signup enabled', default: true },
        { kind: 'select', key: 'register_default_role', label: 'Default role on signup', default: 'customer', options: [
          { value: 'customer', label: 'Customer' },
          { value: 'vendor', label: 'Vendor (must apply)' },
        ] },
        { kind: 'boolean', key: 'require_email_verification', label: 'Require email verification before login', default: true },
        { kind: 'boolean', key: 'enable_recaptcha_signup', label: 'reCAPTCHA on signup form', default: false },
      ],
    },
    {
      label: 'Password policy',
      fields: [
        { kind: 'number', key: 'min_password_length', label: 'Minimum password length', default: 8, min: 6, max: 64 },
        { kind: 'boolean', key: 'require_password_uppercase', label: 'Require an uppercase letter', default: false },
        { kind: 'boolean', key: 'require_password_number', label: 'Require a number', default: false },
        { kind: 'boolean', key: 'require_password_symbol', label: 'Require a symbol', default: false },
      ],
    },
    {
      label: 'Account behaviour',
      fields: [
        { kind: 'boolean', key: 'allow_account_deletion', label: 'Allow self-serve account deletion', default: true },
        { kind: 'boolean', key: 'enable_2fa', label: '2FA available in account settings', default: false, description: 'Encryption setup pending — see PRODUCTION_TODO.md.' },
      ],
    },
  ],
};
